import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeClass: { type: String, default: "tab-active" },
    hiddenClass: { type: String, default: "hidden" }
  }

  connect() {
    if (!this.hasActiveTab()) {
      this.activateTab(this.tabTargets[0])
    }
  }

  switch(event) {
    this.activateTab(event.currentTarget)
  }

  activateTab(tab) {
    const key = tab.getAttribute("aria-controls")

    this.tabTargets.forEach((t) => {
      const selected = t === tab
      t.classList.toggle(this.activeClassValue, selected)
      t.setAttribute("aria-pressed", selected.toString())
    })

    this.panelTargets.forEach((panel) => {
      const panelKey = panel.dataset.tabPanel || panel.id
      panel.classList.toggle(this.hiddenClassValue, panelKey !== key)
    })
  }

  hasActiveTab() {
    return this.tabTargets.some(tab => tab.classList.contains(this.activeClassValue))
  }
}
